import ConversationActions from './conversation';
import Router from '../utils/router';
import ConversationCreatorActionTypes from '../types/conversation_creator';
import Q from 'q';

const ConversationCreatorActions = { types: ConversationCreatorActionTypes };

ConversationCreatorActions.show = function() {
  return {
    type: ConversationCreatorActions.types.SHOW
  };
};

ConversationCreatorActions.hide = function() {
  return {
    type: ConversationCreatorActions.types.HIDE
  };
};

ConversationCreatorActions.disable = function() {
  return {
    type: ConversationCreatorActions.types.DISABLE
  };
};

ConversationCreatorActions.enable = function() {
  return {
    type: ConversationCreatorActions.types.ENABLE
  };
};


ConversationCreatorActions.updateHasState = function (hasState) {
  return {
    type: ConversationCreatorActions.types.HAS_STATE,
    hasState: hasState
  };
};

ConversationCreatorActions.open = function (options) {
  return function(dispatch, getState) {
    if (!getState().conversationCreator.visible) {
      dispatch(ConversationActions.deselect());
      dispatch(ConversationCreatorActions.show());

      if (options && options.transitionRoute) {
        Router.transitionTo('/conversations/new');
      }
    }
  };
};

ConversationCreatorActions.close = function (options) {
  return function(dispatch, getState) {
    var state = getState();
    if (!state.conversationCreator.visible) { return true; }
    var closeComponent = true;
    options || (options = {});

    if (!options.skipConfirm && state.conversationCreator.hasState) {
      closeComponent = confirm('Are you sure? You will lose all unsaved changes.');
    }

    if (closeComponent) {
      dispatch(ConversationCreatorActions.hide());

      if (options.transitionRoute) {
        Router.transitionTo('/conversations');
      }
    }

    return closeComponent;
  };
};

ConversationCreatorActions.createConversation = function(data) {
  return function(dispatch) {
    dispatch(ConversationCreatorActions.disable());

    return Q($.ajax({
      url: '/conversations',
      type: 'POST',
      data: { participant_ids: data.participant_ids, conversation_message: data.message },
      dataType: 'json'
    })).then(response => {
      dispatch(ConversationCreatorActions.close({ skipConfirm: true }));
      dispatch(ConversationActions.selectConversation(response.data.activeConversation));
      dispatch(ConversationActions.receiveAndReorder(response.data.conversations.edges[0]));

      Router.transitionTo('/conversations/:id/messages', { id: response.data.activeConversation.id });
    }, failure => {
      dispatch(ConversationCreatorActions.enable());
      return failure;
    });
  };
};

export default ConversationCreatorActions;
